// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/rc-align/es/index.js
// module id = 908
// module chunks = 20